import React, { useContext, useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { CircularProgress } from "@mui/material";
import analyticsService from "../../../../services/analyticsService";
import { AuthContext } from "../../../../authentication/AuthContext";
import { getDateRangeFromFilter } from "../../../../utils/dateFilterUtils";

const MostRepeatedUserQueries = ({ filter, preview, full, dateFilterValue }) => {
  const { user } = useContext(AuthContext);
  const [queriesData, setQueriesData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (!user?.client_id) return;
      try {
        setLoading(true);
        const dateRange = getDateRangeFromFilter(dateFilterValue);
        const response = await analyticsService.getMostRepeatedUserQueries(
          user.client_id,
          dateRange.start_date,
          dateRange.end_date
        );
        if (response.success && response.data) {
          setQueriesData(response.data);
        }
      } catch (error) {
        console.error("Error fetching most repeated user queries:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [user?.client_id, dateFilterValue]);

  const categories = queriesData.map(item => item.user_query || "(empty)");
  const data = queriesData.map(item => item.session_count || 0);

  const state = {
    series: [
      {
        name: "Query Count",
        data: data,
      },
    ],

    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: { show: false },
      },

      colors: ["#6D5DD2"], // Purple theme

      plotOptions: {
        bar: {
          borderRadius: 6,
          horizontal: true,
          borderRadiusApplication: "end",
        },
      },

      dataLabels: {
        enabled: false,
      },

      xaxis: {
        categories: categories,
        labels: {
          style: {
            fontSize: "12px",
            fontWeight: 500,
            colors: "#6A6A6A",
          },
        },
      },

      grid: {
        strokeDashArray: 4,
        borderColor: "#E6E6E6",
      },

      tooltip: {
        enabled: true,
        theme: "light",
      },
    },
  };

  return (
    <div>
      <h3 style={{ marginBottom: "8px", color: "#6D5DD2" }}>
        Most Repeated User Queries
      </h3>

      <div id="chart">
        {loading ? (
          <CircularProgress />
        ) : (
          <ReactApexChart
            options={state.options}
            series={state.series}
            type="bar"
            height={350}
          />
        )}
      </div>
    </div>
  );
};
 
export default MostRepeatedUserQueries;